import * as r from 'ramda';

const getStatistics = r.prop('statistics');

const getSalesReport = r.pipe(getStatistics, r.prop('salesReport'));

export { getStatistics, getSalesReport };
